import React from "react";
import { Card, Spin, Empty, Space, Tag, Button } from "antd";
import {
  AppstoreOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";

const CategoryList = ({
  categories,
  loading,
  selectedCategory,
  onSelectCategory,
  onAddCategory,
  onEditCategory,
  onDeleteCategory,
}) => {
  const handleDelete = (category, e) => {
    e.stopPropagation();
    Modal.confirm({
      title: "Delete Category",
      content: `Are you sure you want to delete "${category.name}"? This action cannot be undone.`,
      okText: "Delete",
      okType: "danger",
      onOk: () => onDeleteCategory(category.id),
    });
  };

  return (
    <Card
      title={
        <Space>
          <AppstoreOutlined />
          <span>Categories</span>
        </Space>
      }
      extra={
        <Button type="primary" icon={<PlusOutlined />} onClick={onAddCategory}>
          <span className="d-none d-md-inline">Add</span>
        </Button>
      }
      style={{ height: "100%" }}
    >
      <Spin spinning={loading}>
        {categories.length === 0 ? (
          <Empty
            description="No categories yet"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        ) : (
          <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
            {categories.map((category) => (
              <div
                key={category.id}
                onClick={() => onSelectCategory(category)}
                style={{
                  padding: "12px",
                  marginBottom: "8px",
                  border: "1px solid #f0f0f0",
                  borderRadius: "4px",
                  cursor: "pointer",
                  backgroundColor:
                    selectedCategory?.id === category.id ? "#e6f7ff" : "#fff",
                  transition: "all 0.3s",
                }}
              >
                <div style={{ marginBottom: "8px" }}>
                  <div style={{ fontWeight: 500 }}>{category.name}</div>
                  <div style={{ fontSize: "12px", color: "#888" }}>
                    {category.code}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Tag color={category.is_active === 1 ? "green" : "red"}>
                    {category.is_active === 1 ? "Active" : "Inactive"}
                  </Tag>
                  <Space size="small">
                    <Button
                      type="link"
                      icon={<EditOutlined />}
                      onClick={(e) => {
                        e.stopPropagation();
                        onEditCategory(category);
                      }}
                    />
                    <Button
                      type="link"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={(e) => handleDelete(category, e)}
                    />
                  </Space>
                </div>
              </div>
            ))}
          </div>
        )}
      </Spin>
    </Card>
  );
};

export default CategoryList;
